import type { ReactNode } from 'react'
import styles from './HudPillar.module.css'

type HudPillarProps = {
  num: string
  icon: ReactNode
  title: string
  body: ReactNode
  comingSoon?: boolean
}

// One HUD-framed pillar card: corner brackets, a glowing line-icon, a mono
// index, and the pillar copy (passed in from Page.tsx — unchanged source text).
// `comingSoon` switches to a dimmed, dashed "standby" frame; the <h2> already
// reads "coming soon", so the treatment signals state without duplicate copy.
export function HudPillar({ num, icon, title, body, comingSoon }: HudPillarProps) {
  return (
    <article className={`${styles.card} ${comingSoon ? styles.soon : ''}`}>
      <div className={styles.head}>
        <span className={styles.icon} aria-hidden="true">
          {icon}
        </span>
        <span className={styles.num}>{num}</span>
      </div>
      <h2 className={styles.title}>{title}</h2>
      <p className={styles.body}>{body}</p>
    </article>
  )
}
